import { render, staticRenderFns } from "./UbicationStep.vue?vue&type=template&id=69fa12b1"
import script from "./UbicationStep.vue?vue&type=script&lang=js"
export * from "./UbicationStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports